import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AccountingService } from '../service/accounting.service';
import {
  getReferenceDataSuccess,
} from './accounting.action';
import { selectYearMonthSpan } from './span.selector';
import { changeEndYearMonth, changeStartYearMonth } from './span.action';
import { getMonthlyCashFlowStateSuccess, getMonthlyCashFlowStateError } from './monthly-cashflow.action';
import { hideLoading, showLoading } from '../../core/store/app.actions';

@Injectable({
  providedIn: 'root',
})
export class MonthlyCashflowEffects {

  constructor(
    private actions$: Actions,
    private accountingService: AccountingService,
    private store: Store<any>
  ) {
  }

  showLoadingEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        getReferenceDataSuccess,
        changeStartYearMonth,
        changeEndYearMonth
      ),
      map(() => showLoading())
    );
  });

  hideLoadingEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        getMonthlyCashFlowStateSuccess,
        getMonthlyCashFlowStateError
      ),
      map(() => hideLoading())
    );
  });

  getMonthlyCashFlowStateEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getReferenceDataSuccess, changeStartYearMonth, changeEndYearMonth),
      concatLatestFrom(() => [
        this.store.select(selectYearMonthSpan)
      ]),
      mergeMap(([, yearMonths]) =>
        this.accountingService.getMonthlyCashFlowState(yearMonths).pipe(
          map(monthlyCashFlowState => getMonthlyCashFlowStateSuccess({ monthlyCashFlowState })),
          catchError((error) => of(getMonthlyCashFlowStateError({ error })))
        )
      )
    );
  });
}
